import { useEffect, useRef } from 'react';

const BASE_TITLE = 'Arcana CMS';

export function usePageTitle(pageTitle?: string) {
  const previousTitle = useRef<string>(document.title);

  useEffect(() => {
    if (!pageTitle) {
      document.title = BASE_TITLE;
      return;
    }

    const newTitle = `${BASE_TITLE} - ${pageTitle}`;
    document.title = newTitle;

    return () => {
      document.title = previousTitle.current || BASE_TITLE;
    };
  }, [pageTitle]);
}
